// extracted by mini-css-extract-plugin
export default {"icon":"WorkflowActionsPopup_icon__e5lrG","container":"WorkflowActionsPopup_container__Uc4dG","jupyter-icon":"WorkflowActionsPopup_jupyter-icon__VXLu8"};